// extracted by mini-css-extract-plugin
export default {"product_list_long_description":"product_list_long_description_L94Naq5q","product_tab_titles":"product_tab_titles_GsC_U6Nv","warning_message":"warning_message_d4KXaBUI"};